import axios from "axios";
import React, { useCallback } from "react";

import MonitorLineChart from "./MonitorLineChart";
import {
  formatIncomingData,
  MONITOR_HISTORY_RANGE_OPTIONS,
  normalizeMonitorRowsForUptimeChart,
} from "../utils/monitorChartUtils";

export default function VpnPingChart({ deviceUuid }) {
  const loadChartState = useCallback(
    async ({ deviceUuid: id, timestampISO }) => {
      const qp = new URLSearchParams({ timestamp: timestampISO });
      const response = await axios.get(`/device/${id}/monitor/vpn_ping?${qp.toString()}`);
      const raw = response?.data?.vpn_pings;
      if (!Array.isArray(raw) || raw.length === 0) return { data: [], errorAreas: [] };
      return formatIncomingData(normalizeMonitorRowsForUptimeChart(raw));
    },
    []
  );

  return (
    <MonitorLineChart
      deviceUuid={deviceUuid}
      loadChartState={loadChartState}
      showHistory
      showInterval={false}
      defaultHistory="1h"
      historyOptions={MONITOR_HISTORY_RANGE_OPTIONS}
      initialLoading={Boolean(deviceUuid)}
    />
  );
}
